/* eslint-disable no-nested-ternary */
const usePostsTable = ({ resourcesList = [], leavePostsList = {} }) => {
  const sortingFunctions = {
    sortResourceByName: (rowA, rowB) => {
      const resourceAId = rowA.original.resourceId;
      const resourceA = resourcesList?.find((res) => res.id === resourceAId);
      const resourceBId = rowB.original.resourceId;
      const resourceB = resourcesList?.find((res) => res.id === resourceBId);

      return resourceA?.firstName?.localeCompare(resourceB?.firstName);
    },
    sortDuration: (rowA, rowB) => {
      const durationA = rowA.original.businessDaysSlotCount / 2;
      const durationB = rowB.original.businessDaysSlotCount / 2;
      return durationA > durationB ? 1 : (durationA < durationB ? -1 : 0);
    },
    sortLeaveType: (rowA, rowB) => {
      const typeA = leavePostsList?.[rowA.original.id]?.type;
      const typeB = leavePostsList?.[rowB.original.id]?.type;
      return typeA?.localeCompare(typeB);
    },
  };

  return {
    sortingFunctions,
  };
};

export default usePostsTable;
